export default {
  name: 'svgIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.65);'
    },
    size: {
      type: Number,
      default: 16
    }
  },
  data() {
    return {};
  },
  computed: {
    iconName() {
      return `#icon-${this.icon}`;
    }
  }
};